<div class="navblock">
  <app-group-filter #groupFilter [isEditable]="false"></app-group-filter>
  <div></div>
  <div class="inputgroup">
    <input type="text" class="dtpickerupleft" value="" />
  </div>
  <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
</div>
<div class="tablewrap gas-top">

  <div class="gas-small-item">
    <div class="gas-sub-item" id="objects_total">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Objects' | translate}}</div>
    </div>
    <div class="gas-sub-item" id="drivers_total">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Drivers' | translate}}</div>
    </div>
  </div>

  <div class="gas-small-item">
    <div class="gas-sub-item" id="geozones_total">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Geozones' | translate}}</div>
    </div>
    <div class="gas-sub-item" id="total_engine_time">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Engine time' | translate}}</div>
    </div>
  </div>
  <div class="gas-small-item">
    <div class="gas-sub-item" id="total_mileage">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Mileage' | translate}}</div>
    </div>
    <div class="gas-sub-item" id="total_consumption">
      <div class="azs_item_value azs_item_green"></div>
      <div class="azs_item_name">{{'Fuel consumption' | translate}}</div>
    </div>
  </div>

  <div class="gas-item" id="daily_mileage_trend">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="top_objects_mileage">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="objects_states_pie">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="speed_trend">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="daily_fuelling_trend">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>

  <div class="gas-item" id="top_objects_fuel">
    <div class="chart_wrap">
      <canvas></canvas>
    </div>
  </div>
</div>

<div class="tablenav">
  <app-pagination [viewmode]="'print'" ></app-pagination>
</div>
